import seo from '@/core/data/landingSeo.json'

const L = seo.locales.zh

export default {
  landing: {
    title: L.title,
  },
  home: {
    title: L.title,
  },
  upload: {
    title: "上传图片",
  },
  login: {
    title: "登录",
  },
  result: {
    title: "图片分析",
  },
  confirm: {
    title: "邮箱已确认",
  },
  terms: {
    title: "服务条款",
  },
  privacy: {
    title: "隐私政策",
  },
  blog: {
    title: "照片后期指南与概念 | PhotoScope 博客",
    subtitle: "借助参考照片学习照片后期。浏览关于影调、色彩与风格差异的实用指南，帮助摄影初学者有意识地精进修图。",
  },
  history: {
    title: "历史记录",
  },
  about: {
    title: "关于我们 - PhotoScope",
  },
  payment: {
    success: "支付成功",
    cancel: "支付取消",
  },
  dashboard: {
    title: "控制面板",
  },
  tools: {
    title: "免费摄影工具",
  },
};
